export class OperationEventReferenceModel {
    operationEventId: string;
    organisationId: string;
    operationEventCode: string;
    operationEventName: string;
}